import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { PublicSiteFrame } from "./PublicSiteFrame";
import logo from "../assets/logo.png";

const ThankYouPage = () => {
  return (
    <PublicSiteFrame>
      <Card>
        <Box justifyContent="center" display="flex">
          <Box maxWidth="66ch">
            <Box sx={{ padding: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
              <Stack direction="column" alignItems="center" spacing={3}>
                <img src={logo} alt="" style={{ width: 100, height: "auto" }} />

                <Typography align="center" variant="h3" gutterBottom>
                  Thank You!
                </Typography>

                <Typography align="center" variant="h6" color="text.secondary">
                  Your play test feedback has been submitted.
                </Typography>

                <Typography align="center" variant="body1">
                  Your feedback is valuable and helps game designers improve their games. The designer will receive your
                  comments and may use them to enhance the game experience.
                </Typography>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Card>
    </PublicSiteFrame>
  );
};

export const ThankYouFromRoute = () => {
  return <ThankYouPage />;
};
